import React from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { reportOption } from "../../utilities";
import { updateReportAction } from "../../store/actions/AuthActions";
import { useDispatch } from "react-redux";
const Reportselect = () => {
  const reportType = useSelector((state) => state.auth?.reportType);
  const dispatch = useDispatch();
  return (
    <div>
      <Select
        className="react-select"
        classNamePrefix="select"
        options={reportOption}
        value={reportType}
        onChange={(selected) => {
          dispatch(updateReportAction(selected));
        }}
        styles={{
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
          }),
        }}
      />
    </div>
  );
};

export default Reportselect;
